export const MuiTableSortLabel = {
	styleOverrides: {
		root: () =>
			({
				'&.MuiTableSortLabel-root': {
					flexDirection: 'row',
					color: 'inherit',
				},
			} as any),
	},
};
